import React from 'react'

import { Tab } from '@octane/spark'
import { Field, FieldProps } from 'formik'

type FormikTabSelectProps = {
    name: string
    label: string
    children: TabItem[]
    info?: React.ReactNode
    onChange?: (value: string) => void
    prefilled?: boolean
}

export type TabItem = {
    label: string
    value: string
    disabled?: boolean
}

function FormikTabSelect({
    name,
    label,
    children,
    info,
    onChange = () => null,
    prefilled = false,
}: Readonly<FormikTabSelectProps>) {
    return (
        <Field name={name}>
            {({ field, form }: FieldProps) => {
                return (
                    <div>
                        <Tab
                            id={field.name}
                            data-testid={name}
                            value={field.value}
                            label={label}
                            info={info}
                            onChange={(value: string) => {
                                const event = {
                                    target: {
                                        name,
                                        value,
                                    },
                                }

                                form.handleChange(event)
                                onChange(value)
                            }}
                            prefilled={prefilled}
                        >
                            <Tab.List>
                                {children.map((child) => {
                                    return (
                                        <Tab.Button
                                            key={`${field.name}-${child.value}`}
                                            value={child.value}
                                            disabled={child.disabled}
                                        >
                                            {child.label}
                                        </Tab.Button>
                                    )
                                })}
                            </Tab.List>
                        </Tab>
                    </div>
                )
            }}
        </Field>
    )
}

export default FormikTabSelect
